<template>
    <div class="mozali-default-dashboard position-relative">
        <div v-if="isLoading" class="root-preloader position-absolute overlay-loader-wrapper">
            <div class="spinner-bounce d-flex align-items-center dashboard-preloader justify-content-center">
                <span class="bounce1 mr-1"/>
                <span class="bounce2 mr-1"/>
                <span class="bounce3 mr-1"/>
                <span class="bounce4"/>
            </div>
        </div>

        <div class="content-wrapper">
            <app-breadcrumb :page-title="$t('attendance_dashboard')" :directory="$t('dashboard')" :icon="'clock'"/>

            <div class="row">
                <div
                    v-for="metric in metricCards"
                    :key="metric.key"
                    class="col-12 col-sm-6 col-xl-4 mb-primary"
                >
                    <article class="mozali-metric card border-0 h-100">
                        <div class="card-body">
                            <div class="mozali-metric__head">
                                <span class="mozali-metric__label">{{ metric.label }}</span>
                                <span class="mozali-metric__icon" :class="metric.badgeClass">
                                    <i :class="metric.icon"></i>
                                </span>
                            </div>
                            <p class="mozali-metric__value mb-0">{{ metric.value }}</p>
                        </div>
                    </article>
                </div>
            </div>

            <section class="mozali-command card border-0 mb-primary">
                <div class="card-body p-primary">
                    <div class="row">
                        <div class="col-12 col-xl-6 mb-3 mb-xl-0">
                            <article class="mozali-command-panel h-100">
                                <p class="mozali-command-panel__eyebrow mb-2">{{ $t('attendance_command_center') }}</p>
                                <h2 class="mozali-command-panel__title mb-3">{{ currentDateLabel }}</h2>

                                <div class="d-flex align-items-center flex-wrap mozali-gauge-wrap">
                                    <div class="mozali-gauge" :style="gaugeStyle">
                                        <div class="mozali-gauge__inner">
                                            <strong>{{ rateLabel }}</strong>
                                            <span>{{ $t('attendance_rate') }}</span>
                                        </div>
                                    </div>

                                    <div class="mozali-gauge__meta">
                                        <strong class="d-block">{{ presentCoverageLabel }}</strong>
                                        <small class="text-muted">{{ operationalSnapshotLabel }}</small>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div class="col-12 col-xl-6 mb-3 mb-xl-0">
                            <article class="mozali-command-panel h-100">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h5 class="mb-0">{{ $t('operational_pulse') }}</h5>
                                    <span class="badge badge-light">{{ $t('today') }}</span>
                                </div>

                                <div class="mozali-pulse-list">
                                    <div
                                        v-for="segment in pulseSegments"
                                        :key="segment.key"
                                        class="mozali-pulse-item"
                                    >
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <strong>{{ segment.label }}</strong>
                                            <span class="mozali-pulse-item__total">{{ formatMetric(segment.total) }}</span>
                                        </div>
                                        <div class="mozali-pulse-item__values mb-2">
                                            <span>{{ $t('check_ins') }}: {{ formatMetric(segment.checkins) }}</span>
                                            <span>{{ $t('check_outs') }}: {{ formatMetric(segment.checkouts) }}</span>
                                        </div>
                                        <div class="progress mozali-progress">
                                            <div
                                                class="progress-bar"
                                                :class="segment.barClass"
                                                role="progressbar"
                                                :style="{ width: `${segment.percent}%` }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <!-- <div class="col-12 col-xl-3">
                            <article class="mozali-command-panel h-100">
                                <div class="mozali-command-controls">
                                    <div class="mozali-date-controls">
                                        <button type="button" class="btn btn-light btn-sm" @click="shiftDay(-1)">
                                            <i class="fas fa-chevron-left"></i>
                                        </button>

                                        <label class="sr-only" for="dashboardDate">{{ $t('date') }}</label>
                                        <input
                                            id="dashboardDate"
                                            v-model="selectedDate"
                                            type="date"
                                            class="form-control form-control-sm"
                                            @input="refreshDashboard"
                                        />

                                        <button type="button" class="btn btn-light btn-sm" @click="shiftDay(1)">
                                            <i class="fas fa-chevron-right"></i>
                                        </button>
                                    </div>

                                    <button
                                        type="button"
                                        class="btn btn-primary btn-sm btn-block"
                                        :disabled="refreshing"
                                        @click="refreshDashboard"
                                    >
                                        <i class="fas fa-sync-alt" :class="{ 'fa-spin': refreshing }"></i>
                                        <span class="ml-2">{{ $t('refresh_now') }}</span>
                                    </button>

                                    <small class="text-muted d-block">
                                        {{ $t('last_sync') }}: {{ lastSyncLabel }}
                                    </small>
                                </div>

                                <div class="mozali-inline-actions mt-3">
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="goTo('/app-attendances')">
                                        {{ $t('attendance') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="goTo('/app-employees')">
                                        {{ $t('employees') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="goTo('/app-working-shifts')">
                                        {{ $t('working_shift') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="goTo('/app-locations')">
                                        {{ $t('locations') }}
                                    </button>
                                </div>
                            </article>
                        </div> -->
                    </div>
                </div>
            </section>

            <section v-if="!isLoading && !hasAnyOperationalData" class="card border-0 mb-primary mozali-empty-state">
                <div class="card-body p-primary text-center">
                    <div class="mozali-empty-state__icon mb-2">
                        <i class="far fa-calendar-times"></i>
                    </div>
                    <h5 class="mb-2">{{ $t('no_activity_for_selected_day') }}</h5>
                    <p class="text-muted mb-3">{{ $t('no_activity_hint') }}</p>
                    <button type="button" class="btn btn-primary btn-sm" @click="goTo('/app-attendances')">
                        {{ $t('go_to_attendance') }}
                    </button>
                </div>
            </section>

            <div class="row" v-if="alerts.length">
                <div class="col-12 mb-primary">
                    <div class="card border-0 mozali-alerts">
                        <div class="card-header bg-transparent border-0 p-primary pb-0">
                            <h5 class="mb-0">{{ $t('system_alerts') }}</h5>
                        </div>
                        <div class="card-body pt-3">
                            <div
                                v-for="(alert, index) in alerts"
                                :key="`alert-${index}`"
                                class="alert mb-2"
                                :class="alert.type === 'warning' ? 'alert-warning' : 'alert-info'"
                            >
                                {{ alert.message }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-12 col-lg-6 mb-primary">
                    <div class="card border-0 h-100">
                        <div class="card-header bg-transparent border-0 p-primary pb-0 d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">{{ $t('recent_checkins') }}</h5>
                            <span class="badge badge-light">{{ $t('last_30_minutes') }}</span>
                        </div>
                        <div class="card-body pt-3">
                            <div v-if="recentCheckins.length" class="mozali-activity-list">
                                <article
                                    v-for="(item, index) in recentCheckins"
                                    :key="`checkin-${index}`"
                                    class="mozali-activity"
                                >
                                    <div>
                                        <strong class="d-block">{{ item.employee_name || $t('unknown_employee') }}</strong>
                                        <small class="text-muted">{{ item.location || $t('unknown_location') }}</small>
                                    </div>
                                    <span class="badge badge-success">{{ item.time || '--:--' }}</span>
                                </article>
                            </div>
                            <p v-else class="text-muted mb-0">{{ $t('no_recent_checkins') }}</p>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6 mb-primary">
                    <div class="card border-0 h-100">
                        <div class="card-header bg-transparent border-0 p-primary pb-0 d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">{{ $t('recent_checkouts') }}</h5>
                            <span class="badge badge-light">{{ $t('last_30_minutes') }}</span>
                        </div>
                        <div class="card-body pt-3">
                            <div v-if="recentCheckouts.length" class="mozali-activity-list">
                                <article
                                    v-for="(item, index) in recentCheckouts"
                                    :key="`checkout-${index}`"
                                    class="mozali-activity"
                                >
                                    <div>
                                        <strong class="d-block">{{ item.employee_name || $t('unknown_employee') }}</strong>
                                        <small class="text-muted">{{ item.location || $t('unknown_location') }}</small>
                                    </div>
                                    <span class="badge badge-danger">{{ item.time || '--:--' }}</span>
                                </article>
                            </div>
                            <p v-else class="text-muted mb-0">{{ $t('no_recent_checkouts') }}</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin';
import {
    ATTENDANCE_DASHBOARD_SUMMARY,
    ATTENDANCE_REAL_TIME_STATS,
} from '../../../../Config/ApiUrl';

const getTodayDate = () => (
    window.moment
        ? window.moment().format('YYYY-MM-DD')
        : new Date().toISOString().slice(0, 10)
);

const getNowTimestamp = () => (
    window.moment
        ? window.moment().format('YYYY-MM-DD HH:mm:ss')
        : new Date().toISOString()
);

const createEmptySummary = () => ({
    total_employees: 0,
    present_employees: 0,
    absent_employees: 0,
    late_arrivals: 0,
    overtime_employees: 0,
    attendance_timeline: {},
    attendance_by_location: {},
    attendance_by_department: {},
});

const createEmptyRealTime = () => ({
    employees_currently_present: 0,
    recent_checkins: [],
    recent_checkouts: [],
    pending_checkouts: [],
    attendance_rate: 0,
});

export default {
    name: 'Dashboard',
    mixins: [FormMixin],
    data() {
        return {
            isLoading: true,
            refreshing: false,
            selectedDate: getTodayDate(),
            summary: createEmptySummary(),
            metrics: {
                attendance_rate: 0,
            },
            alerts: [],
            realTimeStats: createEmptyRealTime(),
            timelineChartData: {
                labels: [],
                datasets: [],
            },
            locationRows: [],
            lastSyncAt: null,
        };
    },
    computed: {
        currentDateLabel() {
            if (!this.selectedDate) {
                return '';
            }

            if (window.moment) {
                return window.moment(this.selectedDate).format('dddd, DD MMMM YYYY');
            }

            return this.selectedDate;
        },
        coveragePercent() {
            const total = Number(this.summary.total_employees || 0);
            const present = Number(this.summary.present_employees || 0);
            if (!total) {
                return this.safePercent(this.metrics.attendance_rate);
            }

            return this.safePercent((present / total) * 100);
        },
        rateLabel() {
            return `${this.formatPercentValue(this.coveragePercent)}%`;
        },
        presentCoverageLabel() {
            return `${this.$t('present_employees')}: ${this.formatMetric(this.summary.present_employees)} / ${this.formatMetric(this.summary.total_employees)}`;
        },
        pendingCheckoutsCount() {
            return (this.realTimeStats.pending_checkouts || []).length;
        },
        operationalSnapshotLabel() {
            return `${this.$t('currently_present')}: ${this.formatMetric(this.realTimeStats.employees_currently_present)} • ${this.$t('pending_checkouts')}: ${this.formatMetric(this.pendingCheckoutsCount)}`;
        },
        lastSyncLabel() {
            if (!this.lastSyncAt) {
                return '--';
            }

            if (window.moment) {
                return window.moment(this.lastSyncAt).format('HH:mm:ss');
            }

            return this.lastSyncAt;
        },
        gaugeStyle() {
            const angle = Math.round((Number(this.coveragePercent || 0) / 100) * 360);
            return {
                background: `conic-gradient(#1f7ae0 0deg ${angle}deg, #e4ecf8 ${angle}deg 360deg)`,
            };
        },
        pulseSegments() {
            const timeline = this.summary.attendance_timeline || {};
            const windows = [
                { key: 'morning', label: this.$t('morning_window'), start: 6, end: 11 },
                { key: 'midday', label: this.$t('midday_window'), start: 11, end: 15 },
                { key: 'evening', label: this.$t('evening_window'), start: 15, end: 21 },
            ];

            const segments = windows.map((windowRange) => {
                let checkins = 0;
                let checkouts = 0;

                for (let hour = windowRange.start; hour < windowRange.end; hour += 1) {
                    const point = timeline[hour] || timeline[String(hour)] || {};
                    checkins += Number(point.checkins || 0);
                    checkouts += Number(point.checkouts || 0);
                }

                return {
                    ...windowRange,
                    checkins,
                    checkouts,
                    total: checkins + checkouts,
                };
            });

            const maxTotal = Math.max(...segments.map((segment) => segment.total), 1);

            return segments.map((segment) => {
                const percent = Math.round((segment.total / maxTotal) * 100);
                let barClass = 'is-low';

                if (segment.total >= 12) {
                    barClass = 'is-high';
                } else if (segment.total >= 6) {
                    barClass = 'is-medium';
                }

                return {
                    ...segment,
                    percent: Math.max(percent, 8),
                    barClass,
                };
            });
        },
        recentCheckins() {
            return this.realTimeStats.recent_checkins || [];
        },
        recentCheckouts() {
            return this.realTimeStats.recent_checkouts || [];
        },
        hasAnyOperationalData() {
            const hasSummary = Number(this.summary.total_employees || 0) > 0
                || Number(this.summary.present_employees || 0) > 0
                || Number(this.summary.late_arrivals || 0) > 0;
            const hasRealtime = this.recentCheckins.length > 0
                || this.recentCheckouts.length > 0
                || Number(this.realTimeStats.employees_currently_present || 0) > 0;
            const hasLocation = this.locationRows.some((row) => Number(row.count || 0) > 0);

            return hasSummary || hasRealtime || hasLocation;
        },
        metricCards() {
            return [
                {
                    key: 'employees',
                    label: this.$t('employees'),
                    value: this.formatMetric(this.summary.total_employees),
                    icon: 'fas fa-id-badge',
                    badgeClass: 'mozali-badge--indigo',
                },
                {
                    key: 'present',
                    label: this.$t('present_employees'),
                    value: this.formatMetric(this.summary.present_employees),
                    icon: 'fas fa-user-check',
                    badgeClass: 'mozali-badge--green',
                },
                {
                    key: 'absent',
                    label: this.$t('absent_employees'),
                    value: this.formatMetric(this.summary.absent_employees),
                    icon: 'fas fa-user-times',
                    badgeClass: 'mozali-badge--red',
                },
                {
                    key: 'late',
                    label: this.$t('late_arrivals'),
                    value: this.formatMetric(this.summary.late_arrivals),
                    icon: 'fas fa-stopwatch',
                    badgeClass: 'mozali-badge--amber',
                },
                {
                    key: 'present_now',
                    label: this.$t('currently_present'),
                    value: this.formatMetric(this.realTimeStats.employees_currently_present),
                    icon: 'fas fa-signal',
                    badgeClass: 'mozali-badge--teal',
                },
                {
                    key: 'active_locations',
                    label: this.$t('active_locations'),
                    value: this.formatMetric(this.locationRows.filter((row) => Number(row.count || 0) > 0).length),
                    icon: 'fas fa-map-marker-alt',
                    badgeClass: 'mozali-badge--blue',
                },
            ];
        },
    },
    created() {
        this.loadDashboard();
    },
    methods: {
        async loadDashboard() {
            this.isLoading = true;

            const results = await Promise.allSettled([
                this.withTimeout(this.fetchSummary()),
                this.withTimeout(this.fetchRealtime()),
            ]);

            const [summaryResult, realtimeResult] = results;

            if (summaryResult.status === 'rejected') {
                this.summary = createEmptySummary();
                this.metrics = { attendance_rate: 0 };
                this.alerts = [];

                if (this.$toastr) {
                    this.$toastr.e('', this.$resolveError(summaryResult.reason, {key: 'error_loading_data'}));
                }
            }

            if (realtimeResult.status === 'rejected') {
                this.realTimeStats = createEmptyRealTime();

                if (this.$toastr) {
                    this.$toastr.e('', this.$resolveError(realtimeResult.reason, {key: 'error_loading_data'}));
                }
            }

            this.buildTimelineChart();
            this.buildLocationRows();

            if (summaryResult.status === 'rejected' && realtimeResult.status === 'rejected') {
                this.timelineChartData = { labels: [], datasets: [] };
                this.locationRows = [];
            }

            try {
                this.lastSyncAt = getNowTimestamp();
            } finally {
                this.isLoading = false;
                this.refreshing = false;
            }
        },
        refreshDashboard() {
            this.refreshing = true;
            this.loadDashboard();
        },
        withTimeout(promise, timeoutMs = 12000) {
            return Promise.race([
                promise,
                new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('Dashboard request timeout')), timeoutMs);
                }),
            ]);
        },
        shiftDay(step) {
            const increment = Number(step || 0);
            if (!increment) {
                return;
            }

            if (window.moment) {
                this.selectedDate = window.moment(this.selectedDate).add(increment, 'days').format('YYYY-MM-DD');
            } else {
                const date = new Date(`${this.selectedDate}T00:00:00`);
                date.setDate(date.getDate() + increment);
                this.selectedDate = date.toISOString().slice(0, 10);
            }

            this.refreshDashboard();
        },
        normalizeObject(value) {
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                return value;
            }

            return {};
        },
        normalizeDashboardPayload(payload = {}) {
            const safePayload = (payload && typeof payload === 'object') ? payload : {};
            const summary = (safePayload.summary && typeof safePayload.summary === 'object')
                ? safePayload.summary
                : safePayload;
            const metrics = (safePayload.metrics && typeof safePayload.metrics === 'object')
                ? safePayload.metrics
                : safePayload;

            return {
                summary: {
                    total_employees: Number(summary.total_employees || 0),
                    present_employees: Number(summary.present_employees || 0),
                    absent_employees: Number(summary.absent_employees || 0),
                    late_arrivals: Number(summary.late_arrivals || 0),
                    overtime_employees: Number(summary.overtime_employees || 0),
                    attendance_timeline: this.normalizeObject(summary.attendance_timeline),
                    attendance_by_location: this.normalizeObject(summary.attendance_by_location),
                    attendance_by_department: this.normalizeObject(summary.attendance_by_department),
                },
                metrics: {
                    attendance_rate: Number(metrics.attendance_rate || 0),
                },
                alerts: Array.isArray(safePayload.alerts) ? safePayload.alerts : [],
            };
        },
        async fetchSummary() {
            const response = await this.axiosGet(ATTENDANCE_DASHBOARD_SUMMARY, {
                params: { date: this.selectedDate },
            });

            const payload = (response && response.data) ? response.data : {};
            const normalized = this.normalizeDashboardPayload(payload);

            this.summary = normalized.summary;
            this.metrics = normalized.metrics;
            this.alerts = normalized.alerts;
        },
        async fetchRealtime() {
            const response = await this.axiosGet(ATTENDANCE_REAL_TIME_STATS);
            const payload = (response && response.data && typeof response.data === 'object') ? response.data : {};

            this.realTimeStats = {
                employees_currently_present: Number(payload.employees_currently_present || 0),
                recent_checkins: Array.isArray(payload.recent_checkins) ? payload.recent_checkins : [],
                recent_checkouts: Array.isArray(payload.recent_checkouts) ? payload.recent_checkouts : [],
                pending_checkouts: Array.isArray(payload.pending_checkouts) ? payload.pending_checkouts : [],
                attendance_rate: Number(payload.attendance_rate || 0),
            };

            if (!this.metrics.attendance_rate && payload.attendance_rate !== undefined) {
                this.metrics.attendance_rate = Number(payload.attendance_rate || 0);
            }
        },
        buildTimelineChart() {
            const timeline = this.summary.attendance_timeline || {};
            const timelineKeys = Object.keys(timeline)
                .filter((key) => !Number.isNaN(Number(key)))
                .sort((a, b) => Number(a) - Number(b));

            const labels = timelineKeys.map((hour) => `${String(hour).padStart(2, '0')}:00`);
            const checkins = timelineKeys.map((hour) => {
                const point = timeline[hour] || {};
                return Number(point.checkins || 0);
            });
            const checkouts = timelineKeys.map((hour) => {
                const point = timeline[hour] || {};
                return Number(point.checkouts || 0);
            });

            this.timelineChartData = {
                labels,
                datasets: [
                    {
                        label: this.$t('check_ins'),
                        data: checkins,
                        borderColor: '#1f7ae0',
                        backgroundColor: 'rgba(31, 122, 224, 0.15)',
                        pointBackgroundColor: '#1f7ae0',
                        pointBorderColor: '#ffffff',
                        pointRadius: 4,
                        fill: true,
                        tension: 0.35,
                    },
                    {
                        label: this.$t('check_outs'),
                        data: checkouts,
                        borderColor: '#0f9f7f',
                        backgroundColor: 'rgba(15, 159, 127, 0.12)',
                        pointBackgroundColor: '#0f9f7f',
                        pointBorderColor: '#ffffff',
                        pointRadius: 4,
                        fill: true,
                        tension: 0.35,
                    },
                ],
            };
        },
        buildLocationRows() {
            const rows = Object.entries(this.summary.attendance_by_location || {}).map(([name, value]) => {
                const count = Number((value && value.count !== undefined) ? value.count : (value || 0));
                return { name, count };
            });

            const total = rows.reduce((sum, row) => sum + row.count, 0);

            this.locationRows = rows
                .sort((a, b) => b.count - a.count)
                .map((row) => ({
                    ...row,
                    percent: total > 0 ? Math.round((row.count / total) * 100) : 0,
                }))
                .slice(0, 6);
        },
        formatMetric(value) {
            return this.formatCountValue(value);
        },
        safePercent(value) {
            const number = Number(value || 0);
            if (Number.isNaN(number)) {
                return 0;
            }

            return Number(number.toFixed(2));
        },
        goTo(path) {
            window.location.href = path;
        },
    },
};
</script>

<style scoped>
.mozali-default-dashboard {
    --mozali-indigo: #11377f;
    --mozali-primary: #1f7ae0;
    --mozali-cyan: #26b6d5;
    --mozali-green: #04a777;
    --mozali-red: #dc3545;
    --mozali-amber: #f59f00;
    --mozali-teal: #0d9488;
}

.mozali-default-dashboard .content-wrapper {
    position: relative;
    z-index: 2;
}

.mozali-default-dashboard .card {
    border-radius: 14px;
    background: #ffffff;
}

.mozali-command {
    background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 54%, #f3f8ff 100%);
    border: 1px solid #dce8f8;
}

.mozali-command-panel {
    background: #ffffff;
    border: 1px solid #e4ebf6;
    border-radius: 12px;
    padding: 1rem;
}

.mozali-command-panel__eyebrow {
    color: #4b678e;
    letter-spacing: 0.1em;
    font-size: 0.72rem;
    text-transform: uppercase;
    font-weight: 700;
}

.mozali-command-panel__title {
    font-size: clamp(1.08rem, 2.2vw, 1.36rem);
    font-weight: 700;
    color: #10284f;
}

.mozali-gauge {
    width: 132px;
    height: 132px;
    border-radius: 999px;
    padding: 10px;
}

.mozali-gauge-wrap {
    gap: 0.75rem;
}

.mozali-gauge__inner {
    height: 100%;
    width: 100%;
    border-radius: 999px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #e3eaf7;
}

.mozali-gauge__inner strong {
    font-size: 1.15rem;
    color: #123269;
    line-height: 1;
}

.mozali-gauge__inner span {
    margin-top: 0.3rem;
    font-size: 0.74rem;
    color: #64748b;
}

.mozali-gauge__meta {
    flex: 1;
    min-width: 180px;
}

.mozali-command-controls {
    display: grid;
    gap: 0.58rem;
}

.mozali-date-controls {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 0.4rem;
}

.mozali-pulse-list {
    display: grid;
    gap: 0.58rem;
}

.mozali-pulse-item {
    border: 1px solid #e5ebf7;
    border-radius: 10px;
    padding: 0.62rem;
}

.mozali-pulse-item strong {
    color: #17376b;
    font-size: 0.86rem;
}

.mozali-pulse-item__total {
    color: #0f4fae;
    font-weight: 700;
    font-size: 0.85rem;
}

.mozali-pulse-item__values {
    display: flex;
    justify-content: space-between;
    font-size: 0.74rem;
    color: #60708a;
}

.mozali-inline-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
}

.mozali-empty-state {
    border: 1px dashed #cfddee;
    background: #fbfdff;
}

.mozali-empty-state__icon {
    font-size: 1.7rem;
    color: #1f7ae0;
}

.mozali-metric__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.45rem;
}

.mozali-metric__label {
    color: #6c778a;
    font-size: 0.86rem;
    font-weight: 600;
}

.mozali-metric__value {
    font-size: clamp(1.5rem, 2.2vw, 2rem);
    font-weight: 700;
    color: #15284e;
}

.mozali-metric__icon {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.mozali-badge--indigo { background: var(--mozali-indigo); }
.mozali-badge--green { background: var(--mozali-green); }
.mozali-badge--red { background: var(--mozali-red); }
.mozali-badge--amber { background: var(--mozali-amber); }
.mozali-badge--blue { background: var(--mozali-primary); }
.mozali-badge--teal { background: var(--mozali-teal); }

.mozali-breakdown-list {
    display: grid;
    gap: 0.9rem;
}

.mozali-progress {
    height: 0.44rem;
    border-radius: 999px;
    background: #e9eef8;
}

.mozali-progress .progress-bar {
    background: linear-gradient(90deg, #1f7ae0 0%, #26b6d5 100%);
}

.mozali-pulse-item .progress-bar.is-low {
    background: linear-gradient(90deg, #7e8ea5 0%, #a8b5c8 100%);
}

.mozali-pulse-item .progress-bar.is-medium {
    background: linear-gradient(90deg, #1f7ae0 0%, #26b6d5 100%);
}

.mozali-pulse-item .progress-bar.is-high {
    background: linear-gradient(90deg, #0f9f7f 0%, #22c55e 100%);
}

.mozali-alerts {
    border-left: 4px solid #f59f00;
}

.mozali-activity-list {
    display: grid;
    gap: 0.75rem;
}

.mozali-activity {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #eef2f8;
}

.mozali-activity:last-child {
    border-bottom: 0;
    padding-bottom: 0;
}

@media (max-width: 767.98px) {
    .mozali-inline-actions {
        grid-template-columns: 1fr;
    }
}
</style>
